export default `
  fragment KioskImageFragment on Image {
    _type
  }
`;
